import { useState } from 'react'
import { Stack } from '@mui/material'
import { GENERAL_ASSISTANT_INITIAL } from '@/components/Settings/generalConstants'
import { SiaAssistantPreferenceRows } from '@/components/Settings/SiaAssistantPreferenceRows'
import { SiaSettingsFooter } from '@/components/Settings/SiaSettingsFooter'
import { SiaVoiceHistoryRows } from '@/components/Settings/SiaVoiceHistoryRows'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function SiaSettingsContent() {
  const [values, setValues] = useState(() => ({ ...GENERAL_ASSISTANT_INITIAL }))
  const intro = getSettingsSectionIntro('sia')

  return (
    <Stack spacing={2.5} className={shared.briefingsRoot}>
      <Stack component="section" spacing={1.25} className={shared.preferenceSection} aria-label="Sia assistant">
        {intro ? <SettingsSectionIntro lines={intro} /> : null}
        <Stack spacing={0} className={shared.preferenceSectionRows}>
          <SiaAssistantPreferenceRows values={values} setValues={setValues} />
          <SiaVoiceHistoryRows voiceLabel={values.voiceLabel} />
        </Stack>
      </Stack>
      <SiaSettingsFooter />
    </Stack>
  )
}
